// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ColorPickerController from './color_picker_controller'
application.register('color-picker', ColorPickerController)

import CopyController from './copy_controller'
application.register('copy', CopyController)

import ElectionsByStateController from './elections_by_state_controller'
application.register('elections-by-state', ElectionsByStateController)

import EnablerController from './enabler_controller'
application.register('enabler', EnablerController)

import EraserController from './eraser_controller'
application.register('eraser', EraserController)

import ExportController from './export_controller'
application.register('export', ExportController)

import FilterController from './filter_controller'
application.register('filter', FilterController)

import LinkController from './link_controller'
application.register('link', LinkController)

import OrganizationPickerController from './organization_picker_controller'
application.register('organization-picker', OrganizationPickerController)

import PreviewImageController from './preview_image_controller'
application.register('preview-image', PreviewImageController)

import RadioBootstrapButtonsController from './radio_bootstrap_buttons_controller'
application.register('radio-bootstrap-buttons', RadioBootstrapButtonsController)

import RadioToggleController from './radio_toggle_controller'
application.register('radio-toggle', RadioToggleController)

import Select2Controller from './select2_controller'
application.register('select2', Select2Controller)

import SelectChangeController from './select_change_controller'
application.register('select-change', SelectChangeController)

import SelectToFieldController from './select_to_field_controller'
application.register('select-to-field', SelectToFieldController)

import SubmitEnablerController from './submit_enabler_controller'
application.register('submit-enabler', SubmitEnablerController)

import SubmitVisibilityController from './submit_visibility_controller'
application.register('submit-visibility', SubmitVisibilityController)

import TagController from './tag_controller'
application.register('tag', TagController)
